import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';

import { Context } from '../context/DataContext';

const BankTransferInfoPage = () => {
  const navigate = useNavigate();
  const [errorMsg, setErrorMsg] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const { state, updateVirtualAccount } = React.useContext(Context);
  const {
    customerInfo: {
      phone,
      bankName,
      bankId,
      virtualAccount,
      insurancePrice,
      paymentExpireDate,
      orderId,
    },
  } = state;

  return (
    <Box>
      <Typography variant="h4" sx={{ my: 2 }}>
        轉帳付款
      </Typography>
      <Box>
        <Typography variant="h6" sx={{ px: 2, my: 2, textAlign: 'left' }}>
          由於您選擇"ATM/銀行轉帳"方式支付本筆交易，請以以下通知之銀行帳號於繳費期限內完成轉帳付款。
        </Typography>
        <Typography variant="h5" sx={{ px: 2, my: 2, textAlign: 'left' }}>
          {`【轉入銀行】${bankName}(銀行代號: ${bankId})`}
          <br />
          {`【轉帳帳號】${virtualAccount}`}
          <br />
          {`【繳費金額】新台幣 ${insurancePrice} 元`}
          <br />
          {`【繳費期限】${paymentExpireDate}`}
        </Typography>
        <Typography variant="h6" sx={{ px: 2, my: 2, textAlign: 'left', color: 'dodgerblue' }}>
          {`* 溫馨提醒:以上之付款重要訊息將會通過簡訊發送到您的手機${phone ?? ''}中`}
        </Typography>
        {errorMsg ? (
          <Typography variant="h6" sx={{ my: 2, color: 'red' }}>
            {errorMsg}
          </Typography>
        ) : null}
        <LoadingButton
          variant="contained"
          sx={{ width: 168 }}
          loading={loading}
          onClick={() => {
            setLoading(true);
            updateVirtualAccount({ orderId, bankId, virtualAccount }, (data) => {
              const { responseCode, responseMsg } = data;

              if (responseCode === '000') {
                navigate('/upload-photos');
              } else {
                setErrorMsg(responseMsg);
              }
              setLoading(false);
            });
          }}
        >
          下一步
        </LoadingButton>
      </Box>
    </Box>
  );
};

export default BankTransferInfoPage;
